import {
  DialogDescription,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogClose,
  DialogTitle,
  Button,
  Dialog,
  toast,
} from '@ui/components';
import { useNotificationsListStore } from '@pages/notifications/stores';
import { useQueryClient, useMutation } from '@tanstack/react-query';
import { removeNotification } from '@api/notifications';
import { useTranslation } from 'react-i18next';

export const RemoveNotificationsDialog = () => {
  const { t } = useTranslation();

  const queryClient = useQueryClient();

  const {
    setIsRemoveNotificationDialogOpen,
    isRemoveNotificationDialogOpen,
    selectedNotification,
  } = useNotificationsListStore();

  const { mutate: mutateRemoveNotification, isPending: isRemoveNotificationPending } = useMutation({
    mutationFn: (notificationId: string) => removeNotification(notificationId),
    onSuccess: () => {
      setIsRemoveNotificationDialogOpen(false);
      queryClient.invalidateQueries({ queryKey: ['notifications-table'] });
      queryClient.invalidateQueries({ queryKey: ['notifications-count'] });
      toast.success(t('NOTIFICATIONS.REMOVE_NOTIFICATION_DIALOG_SUCCESS'));
    },
    onError: () => {
      toast.error(t('NOTIFICATIONS.REMOVE_NOTIFICATION_DIALOG_ERROR'));
    },
  });

  const handleRemoveNotification = () => {
    mutateRemoveNotification(selectedNotification?.id ?? '');
  };

  return (
    <Dialog
      onOpenChange={(isOpen) => {
        setIsRemoveNotificationDialogOpen(isOpen);
      }}
      open={isRemoveNotificationDialogOpen}
    >
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{t('NOTIFICATIONS.REMOVE_NOTIFICATION_DIALOG_TITLE')}</DialogTitle>
        </DialogHeader>
        <DialogDescription>
          {t('NOTIFICATIONS.REMOVE_NOTIFICATION_DIALOG_DESCRIPTION')}
        </DialogDescription>
        <DialogFooter>
          <DialogClose asChild>
            <Button disabled={isRemoveNotificationPending} variant="tertiary" size="large" wide>
              {t('NOTIFICATIONS.REMOVE_NOTIFICATION_DIALOG_CANCEL')}
            </Button>
          </DialogClose>
          <Button
            isLoading={isRemoveNotificationPending}
            disabled={isRemoveNotificationPending}
            onClick={handleRemoveNotification}
            size="large"
            wide
          >
            {t('NOTIFICATIONS.REMOVE_NOTIFICATION_DIALOG_DELETE')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
